import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAsepriteComponent } from './simple-icons-aseprite.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAsepriteComponent ],
    exports:      [ SimpleIconsAsepriteComponent ],
    bootstrap:    []
})
export class SimpleIconsAsepriteModule {}
